import axios from "axios";
import alert from "@/lang/AlertMessages.js";
import label from "@/lang/StaticLabels.js";
const bankUrl = "finc/api/v1/";

// ساخت کوئری‌استرینگ سرفصل‌های سند
// data می‌تواند همان رشته/آرایه ids قبلی باشد یا آبجکتی به شکل
// { ids, isAggregateVoucherDetail, isAggregateByDebtAndCreditRemain }
// پارامترهای تجمیع فقط وقتی true باشند به آدرس اضافه می‌شوند تا رفتار فعلی تغییر نکند
const buildVoucherQuery = (data) => {
  const isOptions =
    data !== null &&
    typeof data === "object" &&
    !Array.isArray(data) &&
    "ids" in data;

  const { ids, isAggregateVoucherDetail, isAggregateByDebtAndCreditRemain } =
    isOptions ? data : { ids: data };

  let query = "?ids=" + (ids ?? "");
  if (isAggregateVoucherDetail) {
    query += "&isAggregateVoucherDetail=true";
  }
  if (isAggregateByDebtAndCreditRemain) {
    query += "&isAggregateByDebtAndCreditRemain=true";
  }
  return query;
};

export default {
  // CashAccount Actions ------------------------------------------------------------------
  getCashAccounts({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(bankUrl + "basic/CashAccount")
      .then((res) => {
        commit("setCashAccounts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getCashAccount({ dispatch, commit }, data) {
    axios
      .get(bankUrl + "basic/CashAccount/" + data)
      .then((res) => {
        commit("setCashAccount", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCashAccountVoucher({ dispatch, commit }, data) {
    axios
      .get(bankUrl + "basic/CashAccount/Voucher" + buildVoucherQuery(data))
      .then((res) => {
        commit("setCashAccountVoucher", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCashAccountCode({ dispatch, commit }) {
    axios
      .get(bankUrl + "basic/CashAccount/MaxCode")
      .then((res) => {
        commit("setCashAccountCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addCashAccount({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "basic/CashAccount", data)
      .then((res) => {
        commit("setCashAccountId", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCashAccount({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(bankUrl + "basic/CashAccount/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCashAccount({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(bankUrl + "basic/CashAccount", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addCashAccountVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .put(bankUrl + "basic/CashAccount/IssuanceVoucher", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCashAccountVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(bankUrl + "basic/CashAccount/DeleteVoucher/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // BankAccount Actions ------------------------------------------------------------------
  getBankAccounts({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(bankUrl + "basic/BankAccount")
      .then((res) => {
        commit("setBankAccounts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getBankAccount({ dispatch, commit }, data) {
    axios
      .get(bankUrl + "basic/BankAccount/" + data)
      .then((res) => {
        commit("setBankAccount", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBankAccountCode({ dispatch, commit }) {
    axios
      .get(bankUrl + "basic/BankAccount/MaxCode")
      .then((res) => {
        commit("setBankAccountCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addBankAccount({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "basic/BankAccount", data)
      .then((res) => {
        commit("setBankAccountId", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editBankAccount({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(bankUrl + "basic/BankAccount/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteBankAccount({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(bankUrl + "basic/BankAccount", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getBankAccountVoucher({ dispatch, commit }, data) {
    axios
      .get(bankUrl + "basic/BankAccount/Voucher" + buildVoucherQuery(data))
      .then((res) => {
        commit("setBankAccountVoucher", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addBankAccountVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .put(bankUrl + "basic/BankAccount/IssuanceVoucher", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteBankAccountVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(bankUrl + "basic/BankAccount/DeleteVoucher/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // ChequeStatus Actions ------------------------------------------------------------------
  getChequeStatuses({ dispatch, commit }) {
    axios
      .get(bankUrl + "basic/ChequeStatus")
      .then((res) => {
        commit("setChequeStatuses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addChequeStatus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "basic/ChequeStatus", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editChequeStatus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(bankUrl + "basic/ChequeStatus/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteChequeStatus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(bankUrl + "basic/ChequeStatus", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // ChequeBatch Actions ------------------------------------------------------------------
  getChequeBatch({ dispatch, commit }) {
    axios
      .get(bankUrl + "basic/ChequeBatch")
      .then((res) => {
        commit("setChequeBatch", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getChequeBatchCode({ dispatch, commit }) {
    axios
      .get(bankUrl + "basic/ChequeBatch/MaxCode")
      .then((res) => {
        commit("setChequeBatchCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addChequeBatch({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "basic/ChequeBatch", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editChequeBatch({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(bankUrl + "basic/ChequeBatch/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteChequeBatch({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(bankUrl + "basic/ChequeBatch", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // ChequeBatch Actions ------------------------------------------------------------------

  async getChequeBatchDetail({ dispatch, commit }, data) {
    try {
      const res = await axios.get(
        bankUrl + "basic/ChequeBatchDetail?chequeBatchId=" + data,
      );
      commit("setChequeBatchDetail", res.data.data);
    } catch (error) {
      dispatch("errorGETHandler", error, { root: true });
    }
  },

  getChequeBatchDetailCode({ dispatch, commit }) {
    axios
      .get(bankUrl + "basic/ChequeBatch/MaxCode")
      .then((res) => {
        commit("setChequeBatchCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getChequeBatchDetailByNumber({ dispatch, commit }, data) {
    axios
      .get(bankUrl + "basic/ChequeBatchDetail/GetByChequeNumber?" + data)
      .then((res) => {
        commit("setChequeBatchDetailByNumber", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPaymentChequeDetailByNumber({ dispatch, commit }, data) {
    return axios
      .get(bankUrl + "operation/PaymentCheque/GetByChequeNumber?" + data)
      .then((res) => {
        commit("setPaymentChequeDetailByNumber", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addChequeBatchDetail({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "basic/ChequeBatchDetail", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editChequeBatchDetail({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(bankUrl + "basic/ChequeBatchDetail/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteChequeBatchDetail({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(bankUrl + "basic/ChequeBatchDetail", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // ReceiveCash Actions ------------------------------------------------------------------
  getReceiveCashes({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(bankUrl + "operation/ReceiveCash?" + data)
      .then((res) => {
        commit("setReceiveCashes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getReceiveCash({ dispatch, commit }, data) {
    axios
      .get(bankUrl + "operation/ReceiveCash/" + data)
      .then((res) => {
        commit("setReceiveCash", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getReceiveCashCode({ dispatch, commit }) {
    axios
      .get(bankUrl + "operation/ReceiveCash/MaxCode")
      .then((res) => {
        commit("setReceiveCashCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getReceiveCashNavigation({ dispatch, commit }, data) {
    axios
      .get(bankUrl + "operation/ReceiveCash/navigation?" + data)
      .then((res) => {
        commit("setReceiveCashNavigation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // خواندن برگه بعدی یا قبلی بدون تغییر برگه جاری (برای پیمایش پس از حذف)
  fetchReceiveCashNavigation(context, data) {
    return axios
      .get(bankUrl + "operation/ReceiveCash/navigation?" + data)
      .then((res) => res.data.data || null)
      .catch(() => null);
  },

  addReceiveCash({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "operation/ReceiveCash", data)
      .then((res) => {
        commit("setReceiveCashId", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editReceiveCash({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(bankUrl + "operation/ReceiveCash/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addReceiveCashGroup({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "operation/ReceiveCash/CreateList", data)
      .then((res) => {
        const id = res.data.data?.[0]?.id || null;
        const fullData = res.data.data || null;
        const firstData = res.data.data?.[0] || null;
        if (id && fullData) {
          commit("setReceiveCashId", id);
          commit("setReceiveCash", firstData);
          commit("setReceiveCashNavigation", firstData);
          commit("setReceiveCashes", fullData);
        }
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );

        return res.data.data;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editReceiveCashGroup({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .put(bankUrl + "operation/ReceiveCash/Update", data)

      .then((res) => {
        const fullData = res.data.data || null;
        commit("setReceiveCashes", fullData);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return res.data.data;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteReceiveCash({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(bankUrl + "operation/ReceiveCash", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  importExcelReceiveCash({ dispatch, commit }, data) {
    commit("setErrorMessage", [], { root: true });
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "operation/ReceiveCash/ImportAsExcel", data)
      .then((res) => {
        commit("setErrorMessage", res.data.data, { root: true });
        if (res.data.data.length > 0) {
          dispatch(
            "successPOSTHandlerSilent",
            {
              server: res,
              message: alert.success.submit,
              redirect: false,
            },
            { root: true },
          );
        } else {
          dispatch(
            "successPOSTHandler",
            {
              server: res,
              message: alert.success.submit,
              redirect: false,
            },
            { root: true },
          );
        }
        commit("setModalVisibility", false, { root: true });
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // ورود از اکسل تجمیعی دریافت و پرداخت نقد (هر دو نوع در یک فایل)
  importExcelReceivePaymentCash({ dispatch, commit }, data) {
    commit("setErrorMessage", [], { root: true });
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "operation/ReceivePaymentCash/ImportAsExcel", data)
      .then((res) => {
        if (res.status === 202) {
          commit("setErrorMessage", res.data.data.data, { root: true });
        } else {
          dispatch(
            "successPOSTHandler",
            {
              server: res,
              message: res.data.message || alert.success.submit,
              redirect: false,
            },
            { root: true },
          );
          commit("setModalVisibility", false, { root: true });
        }
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addReceiveCashCheckDelete({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "operation/ReceiveCash/CheckDelete", data)
      .then((res) => {
        commit("setReceiveCashCheckDelete", res.data.data);
        dispatch(
          "successPOSTHandlerSilent",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getReceiveCashVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "operation/ReceiveCash/Voucher" + buildVoucherQuery(data))
      .then((res) => {
        commit("setReceiveCashVoucher", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addReceiveCashVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(bankUrl + "operation/ReceiveCash/AddVoucher", data)
      .then((res) => {
        const receiveVoucherNumber = res.data.data?.[0]?.voucherNumber || null;
        const receiveVoucherId = res.data.data?.[0]?.voucherId || null;
        if (receiveVoucherNumber && receiveVoucherId) {
          commit("setReceiveVoucherNumber", receiveVoucherNumber);
          commit("setReceiveVoucherId", receiveVoucherId);
        }
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return res.data.data;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteReceiveCashVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(bankUrl + "operation/ReceiveCash/DeleteVoucher", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintReceiveCashLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "operation/ReceiveCash/PrintReceiveCash/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // PaymentCash Actions ------------------------------------------------------------------
  getPaymentCashes({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(bankUrl + "operation/CashPayment?" + data)
      .then((res) => {
        commit("setPaymentCashes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPaymentCash({ dispatch, commit }, data) {
    axios
      .get(bankUrl + "operation/CashPayment/" + data)
      .then((res) => {
        commit("setPaymentCash", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPaymentCashCode({ dispatch, commit }) {
    axios
      .get(bankUrl + "operation/CashPayment/MaxCode")
      .then((res) => {
        commit("setPaymentCashCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPaymentCashNavigation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "operation/CashPayment/navigation?" + data)
      .then((res) => {
        commit("setPaymentCashNavigation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // خواندن برگه بعدی یا قبلی بدون تغییر برگه جاری (برای پیمایش پس از حذف)
  fetchPaymentCashNavigation(context, data) {
    return axios
      .get(bankUrl + "operation/CashPayment/navigation?" + data)
      .then((res) => res.data.data || null)
      .catch(() => null);
  },

  addPaymentCash({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "operation/CashPayment", data)
      .then((res) => {
        const id = res.data.data?.[0]?.id || null;
        const firstData = res.data.data?.[0] || null;
        const fullData = res.data.data || null;
        if (id && fullData) {
          commit("setPaymentCashId", id);
          commit("setPaymentCash", firstData);
          commit("setPaymentCashNavigation", firstData);
          commit("setPaymentCashes", fullData);
        }
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return res.data.data;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editPaymentCash({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(bankUrl + "operation/CashPayment", data)
      .then((res) => {
        const fullData = res.data.data || null;
        commit("setPaymentCashes", fullData);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return res.data.data;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addPaymentCashCheckDelete({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "operation/CashPayment/CheckDelete", data)
      .then((res) => {
        commit("setPaymentCashCheckDelete", res.data.data);
        dispatch(
          "successPOSTHandlerSilent",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPaymentCashVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "operation/CashPayment/Voucher" + buildVoucherQuery(data))
      .then((res) => {
        commit("setPaymentCashVoucher", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePaymentCash({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(bankUrl + "operation/CashPayment", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  importExcelPaymentCash({ dispatch, commit }, data) {
    commit("setErrorMessage", [], { root: true });
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "operation/CashPayment/ImportAsExcel", data)
      .then((res) => {
        if (res.status === 202) {
          commit("setErrorMessage", res.data.data.data, { root: true });
        } else {
          dispatch(
            "successPOSTHandler",
            {
              server: res,
              message: res.data.message,
              redirect: false,
            },
            { root: true },
          );
          commit("setModalVisibility", false, { root: true });
        }
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addPaymentCashVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(bankUrl + "operation/CashPayment/AddVoucher", data)
      .then((res) => {
        const paymentVoucherNumber = res.data.data?.[0]?.voucherNumber || null;
        const paymentVoucherId = res.data.data?.[0]?.voucherId || null;
        if (paymentVoucherNumber && paymentVoucherId) {
          commit("setPaymentVoucherNumber", paymentVoucherNumber);
          commit("setPaymentVoucherId", paymentVoucherId);
        }
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return res.data.data;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deletePaymentCashVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(bankUrl + "operation/CashPayment/DeleteVoucher", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getPrintPaymentCashLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "operation/CashPayment/PrintCashPayment/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  // RequestPayment Actions ------------------------------------------------------------------
  getRequestPayments({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(bankUrl + "operation/RequestPayment" + (data ? "?" + data : ""))
      .then((res) => {
        commit("setRequestPayments", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  RequestPaymentConfirm({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(bankUrl + "operation/RequestPayment/GetCartable?" + data)
      .then((res) => {
        commit("setRequestPaymentConfirm", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  RequestPaymentChangeStatus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "operation/RequestPayment/ChangeStatus", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  RequestPaymentReturnStatus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "operation/RequestPayment/ReturnStatus", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getRequestPayment({ dispatch, commit }, data) {
    axios
      .get(bankUrl + "operation/RequestPayment/" + data)
      .then((res) => {
        commit("setRequestPayment", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getRequestPaymentCode({ dispatch, commit }) {
    axios
      .get(bankUrl + "operation/RequestPayment/MaxCode")
      .then((res) => {
        commit("setRequestPaymentCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getRequestPaymentNavigation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "operation/RequestPayment/navigation?" + data)
      .then((res) => {
        commit("setRequestPaymentNavigation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addRequestPayment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "operation/RequestPayment", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editRequestPayment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(bankUrl + "operation/RequestPayment/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteRequestPayment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(bankUrl + "operation/RequestPayment", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintPaymentRequestLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "operation/RequestPayment/PrintRequestPayment/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // ReceiveCheque Actions ------------------------------------------------------------------
  getReceiveCheques({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(bankUrl + "operation/ReceiveCheque?" + data)
      .then((res) => {
        commit("setReceiveCheques", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  addReceiveChequeCreateCheck({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(bankUrl + "operation/ReceiveCheque/CreateCheck", data)
      .then((res) => {
        commit("setReceiveChequeCreateCheck", res.data.data);

        dispatch(
          "successPOSTHandlerSilent",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );

        return res.data.data;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        throw error;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getReceiveCheque({ dispatch, commit }, data) {
    axios
      .get(bankUrl + "operation/ReceiveCheque/" + data)
      .then((res) => {
        commit("setReceiveCheque", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getReceiveChequeCode({ dispatch, commit }) {
    axios
      .get(bankUrl + "operation/ReceiveCheque/MaxCode")
      .then((res) => {
        commit("setReceiveChequeCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addReceiveCheque({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "operation/ReceiveCheque", data)
      .then((res) => {
        const id = res.data.data?.[0]?.id || null;
        const fullData = res.data.data || null;
        commit("setReceiveCheques", fullData);
        commit("setReceiveChequeId", id);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return res.data.data;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editReceiveCheque({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(bankUrl + "operation/ReceiveCheque/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addReceiveChequeGroup({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "operation/ReceiveCheque/CreateGroup", data)
      .then((res) => {
        commit("setReceiveCheques", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return res.data.data;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editReceiveChequeGroup({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(bankUrl + "operation/ReceiveCheque/Update", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteReceiveCheque({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(bankUrl + "operation/ReceiveCheque", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getReceiveChequeBackNumber({ dispatch, commit }) {
    axios
      .get(bankUrl + "operation/ReceiveCheque/ChequeBackNumber")
      .then((res) => {
        commit("setReceiveChequeBackNumber", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getReceiveChequeBankTransfer({ dispatch, commit }) {
    axios
      .get(bankUrl + "operation/ReceiveCheque/BankTransfer?")
      .then((res) => {
        commit("setReceiveChequeBankTransfer", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  receiveChequeChangeStatus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(bankUrl + "operation/ReceiveCheque/ChangeStatus", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  receiveChequeReturnStatus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(bankUrl + "operation/ReceiveCheque/ReturnStatus", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getReceiveChequeSampleExcel({ dispatch, commit }) {
    axios
      .get(bankUrl + "operation/ReceiveCheque/ImportAsExcel")
      .then((res) => {
        commit("setReceiveChequeSampleExcel", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  importExcelReceiveCheque({ dispatch, commit }, data) {
    commit("setErrorMessage", [], { root: true });
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "operation/ReceiveCheque/ImportAsExcel", data)
      .then((res) => {
        if (res.status === 202) {
          commit("setErrorMessage", res.data.data.data, { root: true });
        } else {
          dispatch(
            "successPOSTHandler",
            {
              server: res,
              message: alert.success.submit,
              redirect: false,
            },
            { root: true },
          );
          commit("setModalVisibility", false, { root: true });
        }
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintReceiveChequeLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "operation/ReceiveCheque/PrintReceiveCheque/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getReceiveChequeCartable({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(bankUrl + "operation/ReceiveCheque/Cartable" + data)
      .then((res) => {
        commit("setReceiveChequeCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getReceiveChequeVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(
        bankUrl + "operation/ReceiveCheque/Voucher" + buildVoucherQuery(data),
      )
      .then((res) => {
        commit("setReceiveChequeVoucher", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getReceiveChequeNavigation({ dispatch, commit }, data) {
    axios
      .get(bankUrl + "operation/ReceiveCheque/Navigation?" + data)
      .then((res) => {
        commit("setReceiveChequeNavigation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // خواندن برگه بعدی یا قبلی بدون تغییر برگه جاری (برای پیمایش پس از حذف)
  fetchReceiveChequeNavigation(context, data) {
    return axios
      .get(bankUrl + "operation/ReceiveCheque/Navigation?" + data)
      .then((res) => res.data.data || null)
      .catch(() => null);
  },

  getReceiveSearchByPaperNumber({ dispatch, commit }, data) {
    axios
      .get(bankUrl + "operation/ReceiveCheque/Navigation?" + data)
      .then((res) => {
        commit("setReceiveChequeNavigation", res.data.data);
      })
      .catch((error) => {
        if (error.response?.status === 400) {
          commit("setError", alert.error.noPaper, {
            root: true,
          });
          return;
        }
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // BankTransfer Actions ------------------------------------------------------------------
  getBankTransfers({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(bankUrl + "operation/ReceiveCheque/BankTransfer?" + data)
      .then((res) => {
        commit("setBankTransfers", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  async addBankTransfer({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    try {
      const res = await axios.post(
        bankUrl + "operation/ReceiveChequeTurn/BankTransfer",
        data,
      );
      commit("setBankTransferIds", res.data.data);
      dispatch(
        "successPOSTHandler",
        {
          server: res,
          message: res.data.message,
          redirect: false,
        },
        { root: true },
      );
      return res.data.data;
    } catch (error) {
      dispatch("errorPOSTHandler", error, { root: true });
    } finally {
      setTimeout(() => {
        commit("setLoadingBtn", false, { root: true });
      }, 1000);
    }
  },

  getPrintBankTransferLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "operation/ReceiveCheque/PrintBankTransfer/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPrintTurnBankTransfer({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "operation/ReceiveChequeTurn/PrintBankTransfer/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // AssignmentPerson Actions ------------------------------------------------------------------
  getAssignmentPersons({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(bankUrl + "operation/ReceiveCheque/AssignmentPerson?" + data)
      .then((res) => {
        commit("setAssignmentPersons", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // addAssignmentPerson({ dispatch, commit }, data) {
  //   commit("setLoadingBtn", true, { root: true });
  //   axios
  //     .post(bankUrl + "operation/ReceiveChequeTurn/AssignmentPerson", data)
  //     .then((res) => {
  //       commit("setAssignmentPersonIds", res.data.data);

  //       dispatch(
  //         "successPOSTHandler",
  //         {
  //           server: res,
  //           message: res.data.message,
  //           redirect: false,
  //         },
  //         { root: true },
  //       );
  //           return res.data.data;
  //     })
  //     .catch((error) => {
  //       dispatch("errorPOSTHandler", error, { root: true });
  //     })
  //     .finally(() => {
  //       setTimeout(() => {
  //         commit("setLoadingBtn", false, { root: true });
  //       }, 1000);
  //     });
  // },

  async addAssignmentPerson({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    try {
      const res = await axios.post(
        bankUrl + "operation/ReceiveChequeTurn/AssignmentPerson",
        data,
      );
      commit("setAssignmentPersonIds", res.data.data);
      dispatch(
        "successPOSTHandler",
        {
          server: res,
          message: res.data.message,
          redirect: false,
        },
        { root: true },
      );
      return res.data.data;
    } catch (error) {
      dispatch("errorPOSTHandler", error, { root: true });
    } finally {
      setTimeout(() => {
        commit("setLoadingBtn", false, { root: true });
      }, 1000);
    }
  },

  getPrintAssignmentPersonLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "operation/ReceiveCheque/PrintAssignmentPerson/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPrintTurnAssignmentPerson({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl +
          "operation/ReceiveChequeTurn/PrintAssignmentPerson/" +
          data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // Settlement Actions ------------------------------------------------------------------
  getSettlements({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(bankUrl + "operation/ReceiveCheque/Settlement?" + data)
      .then((res) => {
        commit("setSettlements", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addSettlement({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "operation/ReceiveChequeTurn/Settlement", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintsettlementLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "operation/ReceiveCheque/PrintSettlement/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  // ReturnTransferred Actions ------------------------------------------------------------------
  getReturnTransferreds({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(bankUrl + "operation/ReceiveCheque/ReturnTransferred?" + data)
      .then((res) => {
        commit("setReturnTransferreds", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addReturnTransferred({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "operation/ReceiveChequeTurn/ReturnTransferred", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintReturnTransferredLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "operation/ReceiveCheque/PrintReturnTransferred/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // CancellationReceivable Actions ------------------------------------------------------------------
  getCancellationReceivables({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(bankUrl + "operation/ReceiveCheque/CancellationReceivable?" + data)
      .then((res) => {
        commit("setCancellationReceivables", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addCancellationReceivable({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(
        bankUrl + "operation/ReceiveChequeTurn/CancellationReceivable",
        data,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintCancellationReceivableLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl +
          "operation/ReceiveCheque/PrintCancellationReceivable/" +
          data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // ReturnReceivables Actions ------------------------------------------------------------------
  getReturnReceivables({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(bankUrl + "operation/ReceiveCheque/ReturnReceivables?" + data)
      .then((res) => {
        commit("setReturnReceivables", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  async addReturnReceivables({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    try {
      const res = await axios.post(
        bankUrl + "operation/ReceiveChequeTurn/ReturnReceivables",
        data,
      );
      commit("setReturnReceivableIds", res.data.data);
      dispatch(
        "successPOSTHandler",
        {
          server: res,
          message: res.data.message,
          redirect: false,
        },
        { root: true },
      );
      return res.data.data;
    } catch (error) {
      dispatch("errorPOSTHandler", error, { root: true });
    } finally {
      setTimeout(() => {
        commit("setLoadingBtn", false, { root: true });
      }, 1000);
    }
  },

  getPrintReturnReceivableLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "operation/ReceiveCheque/PrintReturnReceivables/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPrintTurnReturnReceivable({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl +
          "operation/ReceiveChequeTurn/PrintReturnReceivables/" +
          data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // ReturnGuarantee Actions ------------------------------------------------------------------
  getReturnGuarantees({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(bankUrl + "operation/ReceiveCheque/ReturnGuarantee?" + data)
      .then((res) => {
        commit("setReturnGuarantees", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // addReturnGuarantee({ dispatch, commit }, data) {
  //   commit("setLoadingBtn", true, { root: true });
  //   axios
  //     .post(bankUrl + "operation/ReceiveChequeTurn/ReturnGuarantee", data)
  //     .then((res) => {
  //       dispatch(
  //         "successPOSTHandler",
  //         {
  //           server: res,
  //           message: res.data.message,
  //           redirect: false,
  //         },
  //         { root: true },
  //       );
  //     })
  //     .catch((error) => {
  //       dispatch("errorPOSTHandler", error, { root: true });
  //     })
  //     .finally(() => {
  //       setTimeout(() => {
  //         commit("setLoadingBtn", false, { root: true });
  //       }, 1000);
  //     });
  // },
  async addReturnGuarantee({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    try {
      const res = await axios.post(
        bankUrl + "operation/ReceiveChequeTurn/ReturnGuarantee",
        data,
      );
      commit("setReturnGuaranteeIds", res.data.data);
      dispatch(
        "successPOSTHandler",
        {
          server: res,
          message: res.data.message,
          redirect: false,
        },
        { root: true },
      );
      return res.data.data;
    } catch (error) {
      dispatch("errorPOSTHandler", error, { root: true });
    } finally {
      setTimeout(() => {
        commit("setLoadingBtn", false, { root: true });
      }, 1000);
    }
  },

  getPrintReturnGuaranteeLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "operation/ReceiveCheque/PrintReturnGuarantee/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPrintTurnReturnGuarantee({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "operation/ReceiveChequeTurn/PrintReturnGuarantee/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // ReturnAssignment Actions ------------------------------------------------------------------
  getReturnAssignments({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(bankUrl + "operation/ReceiveCheque/ReturnAssignment?" + data)
      .then((res) => {
        commit("setReturnAssignments", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // addReturnAssignment({ dispatch, commit }, data) {
  //   commit("setLoadingBtn", true, { root: true });
  //   axios
  //     .post(bankUrl + "operation/ReceiveChequeTurn/ReturnAssignment", data)
  //     .then((res) => {
  //       dispatch(
  //         "successPOSTHandler",
  //         {
  //           server: res,
  //           message: res.data.message,
  //           redirect: false,
  //         },
  //         { root: true },
  //       );
  //     })
  //     .catch((error) => {
  //       dispatch("errorPOSTHandler", error, { root: true });
  //     })
  //     .finally(() => {
  //       setTimeout(() => {
  //         commit("setLoadingBtn", false, { root: true });
  //       }, 1000);
  //     });
  // },
  async addReturnAssignment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    try {
      const res = await axios.post(
        bankUrl + "operation/ReceiveChequeTurn/ReturnAssignment",
        data,
      );
      commit("setReturnAssignmentIds", res.data.data);
      dispatch(
        "successPOSTHandler",
        {
          server: res,
          message: res.data.message,
          redirect: false,
        },
        { root: true },
      );
      return res.data.data;
    } catch (error) {
      dispatch("errorPOSTHandler", error, { root: true });
    } finally {
      setTimeout(() => {
        commit("setLoadingBtn", false, { root: true });
      }, 1000);
    }
  },
  getPrintReturnAssignmentLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "operation/ReceiveCheque/PrintReturnAssignment/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPrintTurnReturnAssignment({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl +
          "operation/ReceiveChequeTurn/PrintReturnAssignment/" +
          data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // ReceiveChequeTurn Actions ------------------------------------------------------------------
  getReceiveChequeTurns({ dispatch, commit }, data) {
    axios
      .get(bankUrl + "operation/ReceiveChequeTurn?receiveChequeId=" + data)
      .then((res) => {
        commit("setReceiveChequeTurns", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getReceiveChequeTurn({ dispatch, commit }, data) {
    axios
      .get(bankUrl + "operation/ReceiveChequeTurn/" + data)
      .then((res) => {
        commit("setReceiveChequeTurn", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addReceiveChequeTurn({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(bankUrl + "operation/ReceiveChequeTurn", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteReceiveChequeTurn({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(bankUrl + "operation/ReceiveChequeTurn", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  changeControlReceiveChequeTurn({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(bankUrl + "operation/ReceiveChequeTurn/ChangeIsChecked", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // PaymentCheque Actions ------------------------------------------------------------------
  getPaymentCheques({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(bankUrl + "operation/PaymentCheque?" + data)
      .then((res) => {
        commit("setPaymentCheques", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPaymentCheque({ dispatch, commit }, data) {
    axios
      .get(bankUrl + "operation/PaymentCheque/" + data)
      .then((res) => {
        commit("setPaymentCheque", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPrintPaymentChequeReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(bankUrl + "report/PrintPaymentChequeReport/" + data.id, data.value)
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPaymentChequeCode({ dispatch, commit }) {
    axios
      .get(bankUrl + "operation/PaymentCheque/MaxCode")
      .then((res) => {
        commit("setPaymentChequeCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addPaymentCheque({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "operation/PaymentCheque", data)
      .then((res) => {
        const id = res.data.data?.[0]?.id || null;
        const fullData = res.data.data || null;
        commit("setPaymentCheques", fullData);
        commit("setPaymentChequeId", id);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return res.data.data;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editPaymentCheque({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(bankUrl + "operation/PaymentCheque/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editPaymentChequeGruop({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(bankUrl + "operation/PaymentCheque/Update", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePaymentCheque({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(bankUrl + "operation/PaymentCheque", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintPaymentChequeLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "operation/PaymentCheque/PrintPaymentCheque/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addPaymentChequeCheckDelete({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "operation/PaymentCheque/CheckDelete", data)
      .then((res) => {
        commit("setPaymentChequeCheckDelete", res.data.data);
        dispatch(
          "successPOSTHandlerSilent",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  paymentChequeChangeStatus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(bankUrl + "operation/PaymentCheque/ChangeStatus", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  paymentChequeReturnStatus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(bankUrl + "operation/PaymentCheque/ReturnStatus", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPaymentChequeNavigation({ dispatch, commit }, data) {
    axios
      .get(bankUrl + "operation/PaymentCheque/Navigation?" + data)
      .then((res) => {
        commit("setPaymentChequeNavigation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // خواندن برگه بعدی یا قبلی بدون تغییر برگه جاری (برای پیمایش پس از حذف)
  fetchPaymentChequeNavigation(context, data) {
    return axios
      .get(bankUrl + "operation/PaymentCheque/Navigation?" + data)
      .then((res) => res.data.data || null)
      .catch(() => null);
  },

  getSearchByPaperNumber({ dispatch, commit }, data) {
    axios
      .get(bankUrl + "operation/PaymentCheque/Navigation?" + data)
      .then((res) => {
        commit("setPaymentChequeNavigation", res.data.data);
      })
      .catch((error) => {
        if (error.response?.status === 400) {
          commit("setError", alert.error.noPaper, {
            root: true,
          });
          return;
        }
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPaymentChequeCartable({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(bankUrl + "operation/PaymentCheque/Cartable" + data)
      .then((res) => {
        commit("setPaymentChequeCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPaymentChequeSampleExcel({ dispatch, commit }) {
    axios
      .get(bankUrl + "operation/PaymentCheque/GetSampleExcel")
      .then((res) => {
        commit("setPaymentChequeSampleExcel", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  importExcelPaymentCheque({ dispatch, commit }, data) {
    commit("setErrorMessage", [], { root: true });
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "operation/PaymentCheque/ImportAsExcel", data)
      .then((res) => {
        if (res.status === 202) {
          commit("setErrorMessage", res.data.data.data, { root: true });
        } else {
          dispatch(
            "successPOSTHandler",
            {
              server: res,
              message: alert.success.submit,
              redirect: false,
            },
            { root: true },
          );
          commit("setModalVisibility", false, { root: true });
        }
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPaymentChequeVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "operation/PaymentCheque/Voucher?ids=" + data)
      .then((res) => {
        commit("setPaymentChequeVoucher", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // PaymentChequeTurn Actions ------------------------------------------------------------------
  getPaymentChequeTurns({ dispatch, commit }, data) {
    axios
      .get(bankUrl + "operation/PaymentChequeTurn?paymentChequeId=" + data)
      .then((res) => {
        commit("setPaymentChequeTurns", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPaymentChequeTurn({ dispatch, commit }, data) {
    axios
      .get(bankUrl + "operation/PaymentChequeTurn/" + data)
      .then((res) => {
        commit("setPaymentChequeTurn", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addPaymentChequeTurn({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(bankUrl + "operation/PaymentChequeTurn", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePaymentChequeTurn({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(bankUrl + "operation/PaymentChequeTurn", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  changeControlPaymentChequeTurn({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(bankUrl + "operation/PaymentChequeTurn/ChangeIsChecked", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // PassPayDocs Actions ------------------------------------------------------------------
  getPassPayDocs({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(bankUrl + "operation/PaymentCheque/PassPayDocs?" + data)
      .then((res) => {
        commit("setPassPayDocs", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addPassPayDocs({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "operation/PaymentChequeTurn/PassPayDocs", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintPassPayDocsLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "operation/paymentCheque/PrintPassPayDocs/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // CancelPayableDocs Actions ------------------------------------------------------------------
  getCancelPayableDocs({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(bankUrl + "operation/PaymentCheque/CancelPayableDocs?" + data)
      .then((res) => {
        commit("setCancelPayableDocs", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addCancelPayableDocs({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "operation/PaymentChequeTurn/CancelPayableDocs", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintCancelPayableDocsLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "operation/paymentCheque/PrintCancelPayableDocs/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // ReturnGuaranteeDocs Actions ------------------------------------------------------------------
  getReturnGuaranteeDocs({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(bankUrl + "operation/PaymentCheque/ReturnGuaranteeDocs?" + data)
      .then((res) => {
        commit("setReturnGuaranteeDocs", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addReturnGuaranteeDocs({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "operation/PaymentChequeTurn/ReturnGuaranteeDocs", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintReturnGuaranteeDocsLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "operation/paymentCheque/PrintReturnGuaranteeDocs/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  //Receipt Recevied ------------------------------------------
  getReceiptRecevied({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(bankUrl + "operation/Receive?" + data)
      .then((res) => {
        commit("setReceiptRecevied", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getExportReceivedPaper({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(bankUrl + "operation/ExportReceivedPaper?" + data)
      .then((res) => {
        commit("setExportReceivedPaper", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getReceiptReceviedById({ dispatch, commit }, data) {
    axios
      .get(bankUrl + "operation/Receive/" + data)
      .then((res) => {
        commit("setReceiptReceviedById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addReceiptRecevied({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "operation/Receive", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "PBANKReceiptReceivedList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  exportReceivedPaper({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "operation/ExportReceivedPaper", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteReceiptRecevied({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(bankUrl + "operation/Receive", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editReceiptRecevied({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(bankUrl + "operation/Receive/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "PBANKReceiptReceivedList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getReceiptReceviedMaxCode({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "operation/Receive/MaxCode")
      .then((res) => {
        commit("setReceiptReceviedMaxCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getReceiptReceviedSearch({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "operation/Order/get/" + data)
      .then((res) => {
        commit("setReceiptReceviedById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getReceiptReceviedNavigation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "operation/Receive/Navigation?" + data)
      .then((res) => {
        commit("setReceiptReceviedNavigation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintReceiveLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(bankUrl + "operation/Receive/PrintReceive/" + data.id, data.value)
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  //Payment Paper ------------------------------------------
  getPaymentPaper({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(bankUrl + "operation/Payment?" + data)
      .then((res) => {
        commit("setPaymentPaper", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPaymentPaperById({ dispatch, commit }, data) {
    axios
      .get(bankUrl + "operation/Payment/" + data)
      .then((res) => {
        commit("setPaymentPaperById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addPaymentPaper({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "operation/Payment", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "PBANKPaymentPaperList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePaymentPaper({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(bankUrl + "operation/Payment", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editPaymentPaper({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(bankUrl + "operation/Payment/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "PBANKPaymentPaperList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPaymentPaperMaxCode({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "operation/Payment/MaxCode")
      .then((res) => {
        commit("setPaymentPaperMaxCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getPaymentPaperSearch({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "operation/Order/get/" + data)
      .then((res) => {
        commit("setPaymentPaperById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPaymentPaperNavigation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "operation/Payment/Navigation?" + data)
      .then((res) => {
        commit("setPaymentPaperNavigation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getPrintPaymentPaperLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(bankUrl + "operation/Payment/PrintPayment/" + data.id, data.value)
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getExportPaymentPaper({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "operation/Payment/ExportPaymentPaperList?" + data)
      .then((res) => {
        commit("setExportPaymentPaper", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  exportPaymentPaper({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "operation/Payment/ExportPaymentPaperCreate", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Reports Actions ------------------------------------------------------------------
  getReceiveChequeReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "Report/ReceiveCheque?" + data)
      .then((res) => {
        commit("setReceiveChequeReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintReceiveChequeReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(bankUrl + "Report/PrintReceiveChequeReport/" + data.id, data.value)
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getReceiveCashAndCahPaymentReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "Report/ReceiveCashAndCahPayment?" + data)
      .then((res) => {
        commit("setReceiveCashAndCahPaymentReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // ریزعملیات حساب بانکی: دریافت/پرداخت نقد و چک‌های وصول/پاس‌شده یک حساب بانکی
  getCashAndChequeOperationDetailReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "Report/CashAndChequeOperationDetailReport", data)
      .then((res) => {
        commit("setCashAndChequeOperationDetailReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // چاپ همان سرویسِ چاپ دریافت/پرداخت نقد است و با reportType=0 هر دو سمت را می‌دهد
  getPrintCashAndChequeOperationDetailReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "Report/PrintReceiveCashAndCahPaymentReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPrintReceiveAndPaymentCashReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "Report/PrintReceiveCashAndCahPaymentReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getMonthlyComparisonReceiveAndPaymentCashReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(
        bankUrl + "Report/MonthlyComparisonReceiveCashAndCashPayment?" + data,
      )
      .then((res) => {
        const result = res.data.data;
        commit(
          "setMonthlyComparisonReceiveAndPaymentCashReport",
          Array.isArray(result) ? result : (result && result.data) || [],
        );
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintMonthlyReceiveAndPaymentCashReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl +
          "Report/PrintMonthlyComparisonReceiveCashAndCashPayment/" +
          data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getHistoryReceiveChequeReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "Report/HistoryReceiveCheque?" + data)
      .then((res) => {
        commit("setHistoryReceiveChequeReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintHistoryReceiveChequeReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "Report/PrintHistoryReceiveChequeReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getDueReceiveChequeReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "Report/DueReceiveCheque?" + data)
      .then((res) => {
        commit("setDueReceiveChequeReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintDueReceiveChequeReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "Report/PrintDueReceiveChequeReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getMonthlyComparisonReceiveChequeReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "Report/MonthlyComparisonReceiveCheque?" + data)
      .then((res) => {
        commit("setMonthlyComparisonReceiveChequeReport", res.data.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getPrintMonthlyComparisonReceiveChequeReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "Report/PrintMonthlyComparisonReceiveChequeReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getSummaryReceiveChequeReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "Report/SummaryReceiveCheque?" + data)
      .then((res) => {
        commit("setSummaryReceiveChequeReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getPrintSummaryReceiveChequeReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "Report/PrintSummaryReceiveChequeReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPaymentChequeReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "Report/PaymentCheque?" + data)
      .then((res) => {
        commit("setPaymentChequeReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getHistoryPaymentChequeReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "Report/HistoryPaymentCheque?" + data)
      .then((res) => {
        commit("setHistoryPaymentChequeReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintHistoryPaymentChequeReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "Report/PrintHistoryPaymentChequeReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getMonthlyComparisonPaymentChequeReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "Report/MonthlyComparisonPaymentCheque?" + data)
      .then((res) => {
        commit("setMonthlyComparisonPaymentChequeReport", res.data.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintMonthlyComparisonPaymentChequeReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "Report/PrintMonthlyComparisonPaymentChequeReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPaymentChequeToPersonReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "Report/PaymentChequeToPerson?" + data)
      .then((res) => {
        commit("setPaymentChequeToPersonReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintPaymentChequeToPersonReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "Report/PrintPaymentChequeToPersonReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPaymentChequeToAccountInfoReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "Report/PaymentChequeToAccountInfo?" + data)
      .then((res) => {
        commit("setPaymentChequeToAccountInfoReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintPaymentChequeToAccountInfoReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "Report/PrintPaymentChequeToAccountInfoReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPaymentChequeTurnReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "Report/PaymentChequeTurn?" + data)
      .then((res) => {
        commit("setPaymentChequeTurnReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintPaymentChequeTurnReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "Report/PrintPaymentChequeTurnReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getSummaryPaymentChequeReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "Report/SummaryPaymentCheque?" + data)
      .then((res) => {
        commit("setSummaryPaymentChequeReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintSummaryPaymentChequeReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "Report/PrintSummaryPaymentChequeReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getOverduePaymentChequeReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    const isDetailRequest = data.includes("toSplitCheque=true");
    axios
      .get(bankUrl + "Report/overduePaymentChequeReport?" + data)
      .then((res) => {
        if (isDetailRequest) {
          commit("setOverdueDetailPaymentChequeReport", res.data.data);
        } else {
          commit("setOverduePaymentChequeReport", res.data.data);
        }
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintOverduePaymentChequeReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "Report/PrintOverduePaymentChequeReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getCirculationVoucherReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "Report/CirculationVoucher?" + data)
      .then((res) => {
        commit("setCirculationVoucherReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintCirculationVoucherReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "Report/PrintCirculationVoucherReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getAccountInventoryReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "Report/AccountInventory?" + data)
      .then((res) => {
        commit("setAccountInventoryReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintAccountInventoryReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "Report/PrintAccountInventoryReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getSummaryPaymentChequeTabReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "Report/SummaryPaymentChequeTab?" + data)
      .then((res) => {
        commit("setSummaryPaymentChequeTab", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintSummaryPaymentChequeTabReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "Report/PrintSummaryPaymentChequeTabReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getSummaryReceiveChequeTabReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "Report/SummaryReceiveChequeTab?" + data)
      .then((res) => {
        commit("setSummaryReceiveChequeTab", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintSummaryReceiveChequeTabReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "Report/PrintSummaryReceiveChequeTabReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getSummaryReceiveAndPaymentCashReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "Report/SummaryReceiveAndPaymentCash?" + data)
      .then((res) => {
        commit("setSummaryReceiveAndPaymentCash", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getCashFlowReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(bankUrl + "Report/CashFlowReport", data)
      .then((res) => {
        commit("setCashFlowReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getCashFlowTableTwoReport({ dispatch, commit }, data) {
    axios
      .post(bankUrl + "Report/CashFlowTableTwoReport", data)
      .then((res) => {
        commit("setCashFlowTableTwoReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  // receive and pay ---------------------------------------------
  getReceiveAndPayment({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(bankUrl + "basic/ReceiptPaymentSubject")
      .then((res) => {
        commit("setReceiveAndPayment", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getReceiveAndPaymentById({ dispatch, commit }, data) {
    axios
      .get(bankUrl + "basic/ReceiptPaymentSubject/" + data)
      .then((res) => {
        commit("setReceiveAndPaymentById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addReceiveAndPayment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "basic/ReceiptPaymentSubject", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteReceiveAndPayment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(bankUrl + "basic/ReceiptPaymentSubject/Delete", {
        data: data,
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editReceiveAndPayment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(bankUrl + "basic/ReceiptPaymentSubject/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getReceiveAndPaymentMaxCode({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "basic/ReceiptPaymentSubject/MaxCode")
      .then((res) => {
        commit("setReceiveAndPaymentMaxCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  //issueTrackingType ---------------------------------------------
  getIssueTrackingTypes({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(bankUrl + "basic/IssueTrackingType")
      .then((res) => {
        commit("setIssueTrackingTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  addIssueTrackingType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "basic/IssueTrackingType" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deleteIssueTrackingType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(bankUrl + "basic/IssueTrackingType", {
        data: data,
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  editIssueTrackingType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(bankUrl + "basic/IssueTrackingType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  //RequestPayment Cartable Management ..................................................................................
  getRequestPaymentManagementCartable({ dispatch, commit }, data) {
    axios
      .get(
        bankUrl +
          "operation/RequestPayment/RequestPaymentManagementCartableList?" +
          data,
      )
      .then((res) => {
        commit("setRequestPaymentManagementCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  requestPaymentManagementCartable({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(bankUrl + "operation/RequestPayment/ManagementCartable", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //PaymentCheque Cartable Management ..................................................................................
  getPaymentChequeManagementCartable({ dispatch, commit }, data) {
    axios
      .get(
        bankUrl +
          "operation/PaymentCheque/PaymentChequeManagementCartableList?" +
          data,
      )
      .then((res) => {
        commit("setPaymentChequeManagementCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  paymentManagementCartable({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(bankUrl + "operation/PaymentCheque/ManagementCartable", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //ChequeReceipt Cartable Management ..................................................................................
  getReceiveChequeManagementCartable({ dispatch, commit }, data) {
    axios
      .get(
        bankUrl +
          "operation/ReceiveCheque/ReceiptChequeManagementCartableList?" +
          data,
      )
      .then((res) => {
        commit("setReceiveChequeManagementCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  receiveChequeCartable({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(bankUrl + "operation/ReceiveCheque/ManagementCartable", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //CartableLog ..................................................................................
  getCartableLog({ dispatch, commit }, data) {
    axios
      .get(bankUrl + "operation/CartableLog?" + data)
      .then((res) => {
        commit("setCartableLog", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  //pbankAttachs Actions ..................................................................................
  getPbankAttachs({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + data.action + data.id)
      .then((res) => {
        commit("setPbankAttachs", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addPbankAttachs({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + data.action, data.form)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePbankAttachs({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(bankUrl + data.action, { data: data.id })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //Dashboards Actions ..................................................................................
  getDashboardSixPieCharts({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(bankUrl + "bank/Dashboard/SixPieCharts?" + data)
      .then((res) => {
        commit("setDashboardSixPieCharts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFirstLineChart({ dispatch, commit }, data) {
    // داده را برمی‌گرداند تا داشبورد پاسخ‌های دیررسیده را کنار بگذارد
    return axios
      .get(bankUrl + "bank/Dashboard/FirstLineChart?" + data)
      .then((res) => {
        commit("setFirstLineChart", res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return null;
      });
  },
  getSecondLineChart({ dispatch, commit }, data) {
    // داده را برمی‌گرداند تا داشبورد پاسخ‌های دیررسیده را کنار بگذارد
    return axios
      .get(bankUrl + "bank/Dashboard/SecondLineChart?" + data)
      .then((res) => {
        commit("setSecondLineChart", res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return null;
      });
  },
  getThirdLineChart({ dispatch, commit }, data) {
    // داده را برمی‌گرداند تا داشبورد پاسخ‌های دیررسیده را کنار بگذارد
    return axios
      .get(bankUrl + "bank/Dashboard/ThirdLineChart?" + data)
      .then((res) => {
        commit("setThirdLineChart", res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return null;
      });
  },
  getFourthLineChart({ dispatch, commit }, data) {
    // داده را برمی‌گرداند تا داشبورد پاسخ‌های دیررسیده را کنار بگذارد
    return axios
      .get(bankUrl + "bank/Dashboard/FourthLineChart?" + data)
      .then((res) => {
        commit("setFourthLineChart", res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return null;
      });
  },
  getFifthLineChart({ dispatch, commit }, data) {
    // داده را برمی‌گرداند تا داشبورد پاسخ‌های دیررسیده را کنار بگذارد
    return axios
      .get(bankUrl + "bank/Dashboard/FifthLineChart?" + data)
      .then((res) => {
        commit("setFifthLineChart", res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return null;
      });
  },
  getSixthLineChart({ dispatch, commit }, data) {
    // داده را برمی‌گرداند تا داشبورد پاسخ‌های دیررسیده را کنار بگذارد
    return axios
      .get(bankUrl + "bank/Dashboard/SixthLineChart?" + data)
      .then((res) => {
        commit("setSixthLineChart", res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return null;
      });
  },
  //interBankTransfer ---------------------------------------------
  getInterBankTransfer({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(bankUrl + "operation/BankTransfer?" + data)
      .then((res) => {
        commit("setInterBankTransfer", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getInterBankTransferItem({ dispatch, commit }, data) {
    axios
      .get(bankUrl + "operation/BankTransfer/" + data)
      .then((res) => {
        commit("setInterBankTransferItem", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBankTransferMaxCode({ dispatch, commit }) {
    axios
      .get(bankUrl + "operation/BankTransfer/MaxCode")
      .then((res) => {
        commit("setBankTransferMaxCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getInterBankTransferNavigation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "operation/BankTransfer/Navigation?" + data)
      .then((res) => {
        commit("setInterBankTransferNavigation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  addInterBankTransfer({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "operation/BankTransfer", data)
      .then((res) => {
        const id = res.data.data?.[0]?.id || null;
        const fullData = res.data.data?.[0] || res.data.data || null;
        if (id && fullData) {
          // فرم بعد از ثبت از navigation پر می‌شود. پاسخ سرور بعضی فیلدها را
          // خالی یا با مقدار پیش‌فرض برمی‌گرداند (مثلاً گردش وجوه نقد = 0) و
          // فیلد فرم خالی می‌شد؛ پس مقدار فیلدهای ارسالی همان مقدار ثبت‌شده
          // است و فقط فیلدهایی که سرور تعیین می‌کند از پاسخ خوانده می‌شوند.
          const sent = data.bankTransfers?.[0] || {};
          const serverFields = ["id", "code", "voucherId", "voucherNumber"];
          const saved = { ...fullData };
          Object.keys(sent).forEach((key) => {
            const isServerField =
              serverFields.includes(key) &&
              fullData[key] !== null &&
              fullData[key] !== undefined;
            if (!isServerField) {
              saved[key] = sent[key];
            }
          });
          commit("setInterBankTransferId", id);
          commit("setInterBankTransferItem", saved);
          commit("setInterBankTransferNavigation", saved);
          commit("setInterBankTransfer", fullData);
        }
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deleteInterBankTransfer({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(bankUrl + "operation/BankTransfer", {
        data: data,
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  editInterBankTransfer({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(bankUrl + "operation/BankTransfer", data)
      .then((res) => {
        const fullData = res.data.data || null;
        commit("setInterBankTransfer", fullData);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return res.data.data;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getInterBankTransferVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(bankUrl + "operation/BankTransfer/Voucher" + buildVoucherQuery(data))
      .then((res) => {
        commit("setInterBankTransferVoucher", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addInterBankTransferVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    // شماره/شناسه سندِ برگه قبلی نباید به برگه فعلی برسد
    commit("setBankTransferVoucherNumber", null);
    commit("setBankTransferVoucherId", null);
    return axios
      .post(bankUrl + "operation/BankTransfer/AddVoucher", data)
      .then((res) => {
        const voucherNumber = res.data.data?.[0]?.voucherNumber || null;
        const voucherId = res.data.data?.[0]?.voucherId || null;
        commit("setBankTransferVoucherNumber", voucherNumber);
        commit("setBankTransferVoucherId", voucherId);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return res.data.data;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteInterBankTransferVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(bankUrl + "operation/BankTransfer/DeleteVoucher", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addBankTransferCheckDelete({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(bankUrl + "operation/BankTransfer/CheckDelete", data)
      .then((res) => {
        commit("setBankTransferCheckDelete", res.data.data);
        dispatch(
          "successPOSTHandlerSilent",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getPrintInterBankTransfer({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        bankUrl + "operation/BankTransfer/PrintBankTransfer/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  fetchHamsazFloatAccountConfig() {
    return axios
      .get(bankUrl + "operation/HamsazProject/FloatAccountConfig")
      .then((res) => res.data.data || null)
      .catch(() => null);
  },

  fetchHamsazProjectByBankOrParticipation(context, data) {
    const params = [];
    if (data?.bankCashAccountId) {
      params.push("bankCashAccountId=" + data.bankCashAccountId);
    }
    if (data?.floatAccountId) {
      params.push("floatAccountId=" + data.floatAccountId);
    }
    if (!params.length) return Promise.resolve(null);
    return axios
      .get(
        bankUrl +
          "operation/HamsazProject/ByBankOrParticipation?" +
          params.join("&"),
      )
      .then((res) => res.data.data || null)
      .catch(() => null);
  },
};
